import React from "react";
import { Table } from "../../ui/Table";
import PropTypes from "prop-types";
import { FormatInt } from "../../../utils/FormatData";
const CarrierMessages = ({ data = [], loading }) => {
  const columns = [
    {
      Header: "Operadora",
      accessor: "vc_carrier",
    },
    {
      Header: "Enviados",
      accessor: "i_send",
      Cell: (rowData) => {
        let value = rowData.row.original.i_send;
        return FormatInt(value);
      },
    },
    {
      Header: "Por procesar",
      accessor: "i_pending",
      Cell: (rowData) => {
        let value = rowData.row.original.i_pending;
        return FormatInt(value);
      },
    },
    {
      Header: "Campañas",
      accessor: "i_campaigns",
      Cell: (rowData) => {
        let value = rowData.row.original.i_campaigns;
        return FormatInt(value);
      },
    },
    {
      Header: "API",
      accessor: "i_api",
      Cell: (rowData) => {
        let value = rowData.row.original.i_api;
        return FormatInt(value);
      },
    },
  ];

  return (
    <div className="p-4 bg-white rounded-lg shadow-md">
      <Table
        title="Mensajes por Operadora"
        data={data}
        columns={columns}
        loading={loading}
        config={{ search: true }}
        rowRule={(row) => {
          const raw = Number(row.original.i_pending);
          const abs = Math.abs(raw);
          if (abs > 0) {
            return "bg-yellow-50 text-yellow-700";
          }
        }}
      />
    </div>
  );
};

CarrierMessages.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
};

export default CarrierMessages;
